// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as PDPOptionButton$Showside from "./PDPOptionButton.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function kindToString(kind) {
  if (kind) {
    return "Style";
  } else {
    return "Color";
  }
}
function kindFromString(kind) {
  switch (kind) {
    case "Color":
      return /* Color */0;
    case "Style":
      return /* Style */1;
    default:
      return /* Color */0;
  }
}
function kindToHumanReadable(pluralOpt, kind) {
  var plural = pluralOpt !== undefined ? pluralOpt : false;
  if (kind) {
    if (plural) {
      return "styles";
    } else {
      return "style";
    }
  } else if (plural) {
    return "colors";
  } else {
    return "color";
  }
}
function getSwatchByKind(hideOutOfStock, product, kind) {
  var name = kind ? "Style" : "Color";
  return Belt_Array.map(Belt_Array.keepMap(Belt_Array.map(Product$Showside.getOptionsByName(product, name), function (option) {
    return option.value;
  }), function (swatch) {
    return Belt_Array.getBy(Belt_Array.keep(Product$Showside.getAllVariants(product), function (variant) {
      if (variant.availability !== /* OutOfStock */0) {
        return true;
      } else {
        return !hideOutOfStock;
      }
    }), function (variant) {
      return Caml_obj.equal(Product$Showside.Variant.getOptionValue(variant, name), swatch);
    });
  }), function (variant) {
    return {
      kind: kind,
      variant: variant,
      value: Product$Showside.Variant.getOptionValue(variant, name)
    };
  });
}
function getProductSwatches(hideOutOfStock, limitOpt, product) {
  var supportedSwatches = [/* Color */0];
  return Belt_Array.reduce(supportedSwatches, [], function (acc, kind) {
    if (acc.length === 0) {
      return getSwatchByKind(hideOutOfStock, product, kind);
    } else {
      return acc;
    }
  });
}
function limit(limitOpt, input) {
  var limit$1 = limitOpt !== undefined ? limitOpt : 2;
  return Belt_Array.keepMap(Belt_Array.mapWithIndex(input, function (index, media) {
    if (index > limit$1) {
      return;
    } else {
      return media;
    }
  }), function (a) {
    return a;
  });
}
function ProductSwatches$Minimal(Props) {
  var hideOutOfStockOpt = Props.hideOutOfStock;
  var product = Props.product;
  var mainImage = Props.mainImage;
  var hideOutOfStock = hideOutOfStockOpt !== undefined ? hideOutOfStockOpt : true;
  var productSwatches = getProductSwatches(hideOutOfStock, undefined, product);
  var imageUrls = Belt_Array.map(limit(undefined, productSwatches), function (param) {
    var variant = param.variant;
    return [variant, Product$Showside.getDisplaySwatchImage(product, variant)];
  });
  var match = Belt_Array.get(productSwatches, 0);
  var optionName = match !== undefined && match.kind ? "Style" : "Color";
  var items = Belt_Array.mapWithIndex(imageUrls, function (i, param) {
    var imageUrl = param[1];
    var variant = param[0];
    var tmp = {
      key: String(i),
      className: CSS$Showside.prefix(Cn.make(["w-6 h-6 relative overflow-hidden rounded-full border border-main ring-1", Caml_obj.equal(imageUrl, mainImage) ? "ring-primary" : "ring-gray-200"]))
    };
    var tmp$1 = Product$Showside.Variant.getOptionValue(variant, optionName);
    if (tmp$1 !== undefined) {
      tmp["aria-label"] = Caml_option.valFromOption(tmp$1);
    }
    var tmp$2 = {
      src: imageUrl,
      fit: /* Cover */1,
      priority: 0
    };
    if (variant.name !== undefined) {
      tmp$2.alt = Caml_option.valFromOption(variant.name);
    }
    return React.createElement("div", tmp, React.createElement(SmartImg$Showside.make, tmp$2));
  });
  var renderTruncationMarker = function (param) {
    var truncatedCount = Math.max(productSwatches.length - imageUrls.length | 0, 0);
    var match = Belt_Array.get(productSwatches, 0);
    var label = match !== undefined ? kindToHumanReadable(truncatedCount !== 1, match.kind) : kindToHumanReadable(truncatedCount !== 1, /* Color */0);
    if (truncatedCount !== 0) {
      return React.createElement("div", {
        "aria-label": "" + String(truncatedCount) + " more " + label + "",
        "aria-expanded": false
      }, "+" + truncatedCount.toString() + "");
    } else {
      return null;
    }
  };
  var match$1 = productSwatches.length;
  if (match$1 === 0 || match$1 === 1) {
    return null;
  }
  var match$2 = Belt_Array.get(productSwatches, 0);
  var name = match$2 !== undefined ? kindToHumanReadable(true, match$2.kind) : kindToHumanReadable(true, /* Color */0);
  return React.createElement("div", {
    "aria-label": "product " + name,
    className: CSS$Showside.prefix("flex-grow flex space-x-2 mt-2 items-center")
  }, items, renderTruncationMarker(undefined));
}
ProductSwatches$Minimal.displayName = "ProductSwatches.Minimal";
var Minimal = {
  make: ProductSwatches$Minimal
};
function ProductSwatches$Large(Props) {
  var selectedVariant = Props.selectedVariant;
  var product = Props.product;
  var onChange = Props.onChange;
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config.settings;
  var productCardTitleLineTruncate = match$1.productCardTitleLineTruncate;
  var productSwatches = getProductSwatches(match$1.hideOutOfStock, undefined, product);
  var items = Belt_Array.map(limit(undefined, productSwatches), function (param) {
    var variant = param.variant;
    var onHover = function (param) {
      Curry._1(onChange, variant);
    };
    var value = {
      TAG: /* ImageSwatch */0,
      _0: Product$Showside.getDisplaySwatchImage(product, variant)
    };
    var selected = selectedVariant.id === variant.id;
    var label = Belt_Option.getWithDefault(param.value, "");
    var handleClick = function (param) {
      Curry._1(onChange, variant);
    };
    return React.createElement(PDPOptionButton$Showside.SwatchButton.make, {
      value: value,
      disabled: variant.availability === /* OutOfStock */0,
      selected: selected,
      label: label,
      size: productCardTitleLineTruncate === 1 ? /* Xs */0 : /* Sm */1,
      stopPropagation: false,
      onClick: handleClick,
      onHover: onHover,
      dataId: label,
      dataTestId: param.kind ? "product-card-style-button" : "product-card-color-button",
      alt: product.name,
      key: variant.id
    });
  });
  var truncated = productSwatches.length - items.length | 0;
  var renderTruncationMarker = function (param) {
    var match = Belt_Array.get(productSwatches, 0);
    var name = match !== undefined ? kindToHumanReadable(undefined, match.kind) : kindToHumanReadable(undefined, /* Color */0);
    return React.createElement(ConditionalRender$Showside.When.make, {
      condition: truncated > 0,
      children: React.createElement("div", {
        "aria-label": "" + String(truncated) + " more " + name + "" + (truncated === 1 ? "" : "s") + "",
        "aria-expanded": false,
        className: CSS$Showside.prefix(Cn.make(["text-base flex items-center justify-center text-tertiary", productCardTitleLineTruncate === 1 ? "w-8 h-8" : "w-10 h-10"]))
      }, "+" + String(truncated) + "")
    });
  };
  var match$2 = items.length;
  if (match$2 === 0 || match$2 === 1) {
    return null;
  }
  var match$3 = Belt_Array.get(productSwatches, 0);
  var name = match$3 !== undefined ? kindToHumanReadable(true, match$3.kind) : kindToHumanReadable(true, /* Color */0);
  return React.createElement("div", {
    "aria-label": "product " + name,
    className: CSS$Showside.prefix("flex flex-wrap gap-2 items-center")
  }, items, renderTruncationMarker(undefined));
}
ProductSwatches$Large.displayName = "ProductSwatches.Large";
var Large = {
  make: ProductSwatches$Large
};
export { kindToString, kindFromString, kindToHumanReadable, getSwatchByKind, getProductSwatches, limit, Minimal, Large };
/* react Not a pure module */